import { LinkButton } from '@distribusion/owl-frontend-ui'

import { withPluginSlot } from '@plugins/index'

export default withPluginSlot(LinkButton, 'ui.LinkButton')
